import { ISnotrRoute } from '..';

export default [
  {
    path: '/company-paycheck-template',
    name: 'UnitMainPaycheckLineTemplates',
    meta: {
      title: 'TabTitle.unitMainPaycheckLineTemplates',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/unit-main-paycheck-line-templates.vue'),
  },
] as ISnotrRoute[];
